// extracted by mini-css-extract-plugin
module.exports = {"background":"Highlight_background__Db_pL","background--even":"Highlight_background--even__jWaxF","background--odd":"Highlight_background--odd__GVPnW"};